import React from 'react';
import ReactDOM from 'react-dom'
import { withTranslation } from 'react-i18next';

import ImgIconComp from '../imgcomp';
import WorkstreamListPopup from './modals/workstreamListPopup';
import MeetingTabButton from './meetingTabButton';
import MeetingAddDropdown from './meetingAddDropdown';
import MeetingServices from '../../../src/services/meeting.services';
import IntegrationServices from '../../../src/services/integration.services';
import { getAiTypeActionLabel, getAiTypeActionLabelPlural } from '../../board/utils';
import { CONVERSATION_STATUS } from '../../../src/apps/meetings/models/meeting';

// Tab Bar Menu
class TabBarMenuMeetingTopicTake extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingDetails: this.props.meetingData,
      wsPopUpEnable: false,
      wsId: '',
      wsItems: [],
      goalItems: [],
      krItems: [],
      aiItems: [],
      lmItems: [],
      oneNoteItems: []
    };
    this.MeetingServices = new MeetingServices();
    this.IntegrationServices = new IntegrationServices();
    this.workstreamListPopupClose = this.workstreamListPopupClose.bind(this);
    this.workstreamListPopup = this.workstreamListPopup.bind(this);
    this.addingWorkStreamToMeeting = this.addingWorkStreamToMeeting.bind(this);
    this.closeWsModelBox = this.closeWsModelBox.bind(this);
    this.addObjectiveItem = this.addObjectiveItem.bind(this);
    this.addWorkStreamItem = this.addWorkStreamItem.bind(this);
    this.addKeyResultItem = this.addKeyResultItem.bind(this);
    this.addActionItem = this.addActionItem.bind(this);
    this.addLastMeetingActions = this.addLastMeetingActions.bind(this);
    this.addAttachment = this.addAttachment.bind(this);
    this.afterSaveOps = this.afterSaveOps.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.workstreamListPopupClose, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.workstreamListPopupClose, true);
  }

  workstreamListPopupClose(e) {
    const _this = this;
    const meetingWsContainer = $('#meetingWsListId');
    if (((!$(meetingWsContainer).is(e.target) && $(meetingWsContainer).has(e.target).length === 0))) {
      setTimeout(() => {
        _this.setState({
          wsPopUpEnable: false,
        });
      }, 10);
    }
  }

  workstreamListPopup() {
    const _this = this;
    setTimeout(() => {
      _this.setState({
        wsPopUpEnable: true,
      });
    }, 10);
  }

  addingWorkStreamToMeeting(id, wsName) {
    const meetingId = this.props.meetingObj.id;
    const { actions } = this.props;
    if (meetingId) {
      $.ajax({
        url: `${wbConfig.baseUrl}/meeting/setWorkStreamToMeeting`,
        type: 'POST',
        data: { wsId: id, meetingId },
      })
        .done((response) => {
          if (response) {
            actions.MeetingWorkstreamNameUpdate(id, wsName);
          }
        });
    }
  }

  closeWsModelBox() {
    const _this = this;
    setTimeout(() => {
      _this.setState({
        wsPopUpEnable: false,
      });
    }, 10);
  }

  closePopup() {
    const popupelement = $(meetingAddPopupWrapper);
    if (popupelement != '') {
      ReactDOM.unmountComponentAtNode(document.getElementById('meeting-add-popup-wrapper'));
      $(popupelement).dialog('close');
    }
  }

  afterSaveOps(items, data, create){
    const {currentUser} = this.props
    this.closePopup()
    if(create) {
      create_topic('meet', {
          action: 'add',
          data: items,
          type: 'wobo_object',
          firstname: currentUser.firstname,
          lastname: currentUser.lastname,
      })
    }
    this.props.refreshLegacyData(data)
  }

  addObjectiveItem(params) {
    const {t} = this.props
    this.MeetingServices.saveMeetingObjective(params)
      .then(resp  => {
        toastr.success(params.items.length > 1 ? `${t("'OKRs' added as topic")}` : `${t("'OKR' added as topic")}`)
        this.afterSaveOps(params.items, resp.data.data, true)
      })
  }

  addWorkStreamItem(params) {
    const {t} = this.props
    this.MeetingServices.saveMeetingWorkstream(params)
      .then(resp  => {
        toastr.success(params.items.length > 1 ? `${t("Workstreams added as topic")}` : `${t("Workstream added as topic")}`)
        this.afterSaveOps(params.items, resp.data.data, true)
      })
  }

  addKeyResultItem(params) {
    const {t} = this.props
    this.MeetingServices.saveMeetingKR(params)
      .then(resp  => {
        toastr.success(params.items.length > 1 ? `${t("'KRs' added as topic")}` : `${t("'KR' added as topic")}`)
        this.afterSaveOps(params.items, resp.data.data, true)
      })
  }

   addActionItem(params) {
    const {t} = this.props
    const label = getAiTypeActionLabel();
    this.MeetingServices.saveMeetingAI(params)
      .then(resp  => {
        toastr.success(params.items.length > 1 ? `${t("{{label}}'s added as topic", { label })}` : `${t('{{label}} added as topic', { label })}`)
        this.afterSaveOps(params.items, resp.data.data, true)
      })
  }

  addLastMeetingActions(params) {
    const {t} = this.props
    this.MeetingServices.saveMeetingAI(params)
      .then(resp  => {
        toastr.success(params.items.length > 1 ? `${t("Topics added")}` : `${t("Topic added")}`)
        this.afterSaveOps(params.items, resp.data.data, true)
      })
  }

  addAttachment(params) {
    this.IntegrationServices.createMsOneNote(params)
      .then(resp  => {
        this.afterSaveOps(null, resp.data.data, false)
      })
  }

  render() {
    const { userPermission, t, isConversationMeetingCompleted, isConversationMeetingClosedByHr, isConversationMeetingNotRequired, conversationStatus } = this.props;
    const selectedUser = this.props.meetingObj;
    const meetingOwner = selectedUser.owner;
    const addWsPopup = {
      callback: this.addingWorkStreamToMeeting,
    };
    const workStreamName = selectedUser.wsName ? selectedUser.wsName : t('Set Workstream');
    const meetingId = this.props.meetingObj.id;
    const isShowLastAiIcon = (this.props.isShowLastAiIcon > 0);
    const goalModule = userPermission.goal || false;
    const executeModule = userPermission.execute || false;
    const getAiFromLastMeetingUrl = window.wbConfig.isNewMeetingsEnabled
      ? `restapi/meetings/${meetingId}/actions?subject=history`
      : `meeting/getAiFromLastMeeting?id=${meetingId}`;
    const label = getAiTypeActionLabel();
    const labelPlural = getAiTypeActionLabelPlural();
    const isConversationComplete = isConversationMeetingCompleted || isConversationMeetingClosedByHr || (isConversationMeetingNotRequired && conversationStatus !== CONVERSATION_STATUS.IN_PROGRESS);
    const addMarginRight = t("ADD").length > 3 ? `${t("ADD").length * 5}px` : '8px';

    return (
      <div className={`tabBarMenu ${isConversationComplete ? "conversationMarkCompleted" : ""}`}>
        <div className="left">
          <div className="meeting-button-wrapper">
            <MeetingAddDropdown
              t={t}
              goalModule={goalModule}
              executeModule={executeModule}
              isShowLastAiIcon={isShowLastAiIcon}
              label={label}
              labelPlural={labelPlural}
              getAiFromLastMeetingUrl={getAiFromLastMeetingUrl}
              actions={this.props.actions}
              currentUser={this.props.currentUser}
              meetingId={this.props.meetingObj.id}
              boxApiKey={this.props.boxApiKey}
              dropBoxApiKey={this.props.dropBoxApiKey}
              addObjectiveItem={this.addObjectiveItem}
              addKeyResultItem={this.addKeyResultItem}
              addWorkStreamItem={this.addWorkStreamItem}
              addActionItem={this.addActionItem}
              addAttachment={this.addAttachment}
              addLastMeetingActions={this.addLastMeetingActions}
              closePopup={this.closePopup}
              refreshLegacyData={this.props.refreshLegacyData}
              accessToken={this.props.accessToken}
              appInID={this.props.appInID}
              isFUSEnabled={this.props.isFUSEnabled}
              deleteTopicTakeNonTake={this.props.deleteTopicTakeNonTake}
              msAppId={this.props.msAppId}
              meetingRedirectUrl={this.props.meetingRedirectUrl}
            />
          </div>
        </div>
        {
          (userPermission.meetingAccess && executeModule)
          && (
          <div className="floatRight meetingWorkstreamContainer wsMeetingWidth">
            <div className="displayIn"> {t("Put actions in")}:&nbsp;</div>
            {
              (workStreamName && userPermission.meetingAccess)
                ? (
                  <div className="setWsColor floatRightWs displayIn" onClick={e => this.workstreamListPopup(e)} title={workStreamName}>
                    {' '}
                    {workStreamName}
                  </div>
                )
                : (
                  <div className="setWsColor displayIn">
                    {workStreamName}
                  </div>
                )
            }
            {
              this.state.wsPopUpEnable
                && <WorkstreamListPopup addWsPopup={addWsPopup} closeWsModelBox={this.closeWsModelBox} meetingOwner={meetingOwner} t={t} />
            }
            {
              userPermission.meetingAccess
                && (
                <div className="padLeft10 meetingWorkstreamIcon displayIn cursorStyle" onClick={() => this.addingWorkStreamToMeeting('', 'Set Workstream')}>
                  {' '}
                  <ImgIconComp id="removeWsImg" width="10" height="10" />
                  {' '}
                </div>
                )
            }
          </div>
          )
        }
        <div className="clear" />
      </div>
    );
  }
}
export default withTranslation()(TabBarMenuMeetingTopicTake);
